// Utils
import createHandleCharacterFn from './createHandleCharacterFn';
import commonMarkdownHandlerReturn from './commonMarkdownHandlerReturn';
import { isTerminatingMarkdownCharacter } from './patternMatching/markdownPatternMatcher';

// Constants
import { HANDLER_RETURN_VALUES } from '../../draftjsConstants';

export default ({ enableBlockStyles }) => {
    const handleCharacter = createHandleCharacterFn({ enableBlockStyles });

    return (char, editorState, eventTimeStamp, { setEditorState }) => {
        if (!isTerminatingMarkdownCharacter(char)) return HANDLER_RETURN_VALUES.notHandled;

        const newEditorState = handleCharacter(editorState, char);

        return commonMarkdownHandlerReturn(editorState, newEditorState, { setEditorState });
    };
};
